import React from 'react';
import { withRouter } from 'react-router-dom';
import YouTubeVideoPreview from './../../YouVideoPreview'
import AWS_S3 from 'aws-sdk/clients/s3';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import ButtonContent from '../../../components/ButtonContent';
import { S3_BUCKET_NAME, VIDEO_SIZE_LIMIT_BYTES, MIN_TRANCODEING_VIDEO_SIZE_LIMIT_BYTES } from '../../../constants';
import COLORS from '../../../styles/colors';
import { VALIDATION_MESSAGES } from '../../../static-content';
import { AlertJsMessage } from './../../../helpers.js';

const acceptTypes = ['video/mp4', 'video/quicktime'];
class Form extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			dataLoaded: false,
			editExercise: null,
			isValidating: false,
			isUploading: false,
			submitAction: 'create',
			uploadInput: null,
			fileLoaded: false,
			videoModal: false,
			reqData: {
				name: '',
				description: '',
				equipmentId: null,
				partId: null,
				imgUrl: '',
				videoUrl: '',
			},
		};
	}
	componentDidMount() {
		this.props.fetch(this.props.user._id || localStorage.id, this.props.editId).then(() => {
			const { editId, exercises } = this.props;
			if (editId) {
				if (exercises[editId]) {
					const editExercise = exercises[editId];
					this.setState({
						...this.state,
						dataLoaded: true,
						editExercise: editExercise,
						submitAction: 'edit',
						reqData: {
							name: editExercise.name,
							description: editExercise.description,
							equipmentId: editExercise.equipmentId,
							partId: editExercise.partId,
							imgUrl: editExercise.imgUrl,
							videoUrl: editExercise.videoUrl,
						},
					});
				}
			} else {
				this.setState({
					...this.state,
					submitAction: 'create',
					dataLoaded: true,
				});
			}
		});
	}

	handleChange = field => event => {
		this.setState({
			...this.state,
			reqData: {
				...this.state.reqData,
				[field]: event.target.value,
			},
		});
	};
	handleOpen = () => {
		this.setState({ open: true });
	};

	handleClose = () => {
		this.setState({ open: false });
	};

	handleFileChange({ target }) {
		const file = target.files[0];
		if (file.type === 'video/mp4' || file.type === 'video/quicktime' || file.type === 'video/mov') {
			if (file.size > VIDEO_SIZE_LIMIT_BYTES) {
				AlertJsMessage(VALIDATION_MESSAGES.VIDEO_LIMIT_EXCEEDS(file.size));
				this.setState({
					previewVideoSrc: '',
					fileLoaded: false,
				});
				return;
			} else {
				this.setState({
					uploadInput: target,
					previewVideoSrc: window.URL.createObjectURL(file),
					fileLoaded: true,
				});
			}
		} else {
			AlertJsMessage(
				'File type not supported. Only mp4 and quicktime format are allowed.'
			);
		}
	}

	submitNewFile() {
		this.setState({ isUploading: true });
		const { addFile, showLoader, hideLoader } = this.props;
		showLoader();
		const s3 = new AWS_S3({
			apiVersion: '2006-03-01',
			params: { Bucket: S3_BUCKET_NAME },
		});
		let file;
		file = this.state.uploadInput.files && this.state.uploadInput.files[0];
		const fileType = file && file.name.split('.').pop();
		let s3UploadObj = {
			Key: `exerciseVideo-${Date.now()}.${fileType}`,
			Body: file,
			ACL: 'public-read',
		};
		return new Promise((resolve, rej) => {
			if (file) {
				let isTranscoding;
				if (file.size > MIN_TRANCODEING_VIDEO_SIZE_LIMIT_BYTES || file.type === 'video/quicktime' || file.type === 'video/mov') {
					isTranscoding = true;
				}
				s3.upload(s3UploadObj, (err, ec2Data) => {
					if (err) {
						AlertJsMessage(
							'There was an error uploading your photo: ',
							err.message
						);
						hideLoader();
						rej('');
						return;
					}
					addFile({
						userId: this.props.user._id || localStorage.id,
						url: `https://${process.env.REACT_APP_ASSET_URL}/${ec2Data.Key}`,
						category: 'exerciseVideo',
						fileType: fileType,
						name: file.name,
						isTranscoding: isTranscoding,
					}).then(newFile => {
						hideLoader();
						resolve(newFile);
					});
				});
			} else {
				hideLoader();
				rej('No File');
			}
		});
	}

	validateForm() {
		let reqData = { ...this.state.reqData };
		const { addExercise, edit, editId, user, onClose } = this.props;
		const required = ['name', 'equipmentId', 'partId'];
		for (var i = 0; i < required.length; i++) {
			if (!reqData[required[i]]) {
				AlertJsMessage(required[i] + ' is required.');
				return;
			}
		}

		if (this.state.previewVideoSrc) {
			this.setState({ isValidating: true }, () => {
				this.submitNewFile().then(file => {
					reqData.fileId = file._id;
					reqData.videoUrl = file.url;
					reqData.screenShotUrl = file.screenShotUrl;
					reqData.isTranscoding = file.isTranscoding;
					reqData.jobId = file.jobId;
					if (this.state.submitAction === 'create') {
						addExercise(reqData, user.type).then(() => {
							AlertJsMessage(file.isTranscoding ? 'Exercise has been processing. Once it done then we will inform you.' : 'Exercise has been created successfully.');
							window.location.reload();
						});
					} else {
						edit(editId, reqData, user.type).then(() => {
							onClose && onClose();
							AlertJsMessage(file.isTranscoding ? 'Exercise has been processing. Once it done then we will inform you.' : 'Exercise has been updated successfully.');
							window.location.reload();
						});
					}
				});
			});
		} else {
			AlertJsMessage('Please upload a video.');
		}
	}

	renderMenuOptions = option => (
		<MenuItem key={option._id} value={option._id}>
			{option.name}
		</MenuItem>
	);

	render() {
		const {
			reqData,
			dataLoaded,
			editExercise,
			previewVideoSrc,
			fileLoaded,
		} = this.state;
		const { equipment, cats } = this.props;
		const textFieldPadding = '2% 5% 0 5%';
		return (
			<div style={{ width: '90%', padding: textFieldPadding }}>
				<ul style={{ listStyle: 'disc', padding: textFieldPadding }}>
					<li>
						Please access your dashboard on a desktop to build, share, edit, and
						assign workouts. You can upload video exercises to your library
						straight from your phone.
					</li>
					<br />
					<li>
						Watch the short video on how to make a great looking exercise video
						with your phone.
					</li>
				</ul>
				<YouTubeVideoPreview
					channel="youtube"
					isOpen={this.state.videoModal}
					videoId="voBfUaZn0BU"
					onClose={() => this.setState({ videoModal: false })}
				/>
				<Button
					color="primary"
					variant="contained"
					style={{ display: 'block', margin: 'auto', marginTop: 15 }}
					onClick={() => this.setState({ videoModal: true })}
				>
					<ButtonContent text="Watch Now" />
				</Button>
				<h1>Build Exercise</h1>
				{dataLoaded && (
					<React.Fragment>
						<TextField
							label="Name"
							value={reqData.name}
							onChange={this.handleChange('name')}
							margin="dense"
							variant="outlined"
							inputProps={{ maxLength: 60 }}
							style={{ width: '90%', margin: textFieldPadding }}
						/>
						<TextField
							label="Description (Optional)"
							value={reqData.description}
							onChange={this.handleChange('description')}
							margin="dense"
							variant="outlined"
							inputProps={{ maxLength: 250 }}
							style={{ width: '90%', margin: textFieldPadding }}
						/>
						<TextField
							select
							label="Select Equipment"
							value={reqData.equipmentId}
							onChange={this.handleChange('equipmentId')}
							margin="dense"
							variant="outlined"
							style={{ width: '90%', margin: textFieldPadding }}
						>
							{Object.values(equipment).map(this.renderMenuOptions)}
						</TextField>
						<TextField
							select
							label="Select Body Target"
							value={reqData.partId}
							onChange={this.handleChange('partId')}
							margin="dense"
							variant="outlined"
							style={{ width: '90%', margin: textFieldPadding }}
						>
							{Object.values(cats).map(this.renderMenuOptions)}
						</TextField>
						<div id="mobile-file-selection">
							{fileLoaded && (
								<div
									style={{
										textAlign: 'center',
										height: 150,
										width: '100%',
										border: '2px solid ' + COLORS.grey,
										backgroundColor: COLORS.lightGrey,
									}}
								>
									{previewVideoSrc && (
										<video
											loop
											muted
											autoPlay
											src={previewVideoSrc}
											style={{ height: '100%' }}
											playsInline
										/>
									)}
								</div>
							)}
							<Button
								color="secondary"
								variant="contained"
								component="label"
								style={{ marginTop: 5 }}
							>
								<input
									type="file"
									onChange={e => this.handleFileChange(e)}
									accept={acceptTypes.toString()}
									style={{ display: 'none' }}
								/>
								<ButtonContent text="Upload New Video" icon="upload" />
							</Button>
							<Button
								disabled={this.state.isValidating}
								onClick={() => this.validateForm()}
								variant="contained"
								color="primary"
								style={{ marginTop: 5 }}
							>
								{editExercise ? 'Update Exercise' : 'Add Exercise'}
							</Button>
						</div>
					</React.Fragment>
				)}
			</div>
		);
	}
}

export default withRouter(Form);



// WEBPACK FOOTER //
// ./src/components/exercises/mobileApp/mobileExercise.js